import api from './api';

const customerAccountService = {
  // Get all accounts summary
  getAllAccounts: async (params = {}) => {
    const response = await api.get('/customer-accounts', { params });
    return response.data;
  },

  // Get accounts for a specific customer
  getCustomerAccounts: async (customerUuid) => {
    const response = await api.get(`/customer-accounts/customer/${customerUuid}`);
    return response.data;
  },

  // Get transaction history
  getTransactions: async (params = {}) => {
    const response = await api.get('/customer-accounts/transactions', { params });
    return response.data;
  },

  // Deposit money (customer gives cash)
  deposit: async (customerUuid, data) => {
    const response = await api.post(`/customer-accounts/customer/${customerUuid}/deposit`, data);
    return response.data;
  },

  // Withdraw cash
  withdraw: async (accountUuid, data) => {
    const response = await api.post(`/customer-accounts/${accountUuid}/withdraw`, data);
    return response.data;
  },

  // Give loan to customer
  giveLoan: async (customerUuid, data) => {
    const response = await api.post(`/customer-accounts/customer/${customerUuid}/loan`, data);
    return response.data;
  },

  // Repay loan
  repayLoan: async (accountUuid, data) => {
    const response = await api.post(`/customer-accounts/${accountUuid}/repay`, data);
    return response.data;
  },

  // Delete transaction (admin only)
  deleteTransaction: async (uuid) => {
    const response = await api.delete(`/customer-accounts/transactions/${uuid}`);
    return response.data;
  }
};

export default customerAccountService;
